export class SnapshotRecipeEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "isDirectory",
            "baseName": "isDirectory",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "SnapshotRecipeEntryAction",
            "format": ""
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "SnapshotRecipeEntryReason",
            "format": ""
        },
        {
            "name": "sourceSnapshotId",
            "baseName": "sourceSnapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "size",
            "baseName": "size",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "baseEvidenceType",
            "baseName": "baseEvidenceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "descendantChanges",
            "baseName": "descendantChanges",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sourceSnapshotIds",
            "baseName": "sourceSnapshotIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeEntry.attributeTypeMap;
    }
    constructor() {
    }
}
